// src/pages/HomePage.jsx
import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import "../../../styles/HomePage.css";
import { useLocation, useNavigate } from "react-router-dom";
import centerLogo from "../../../assets/icons/logo.svg";
import { FaStop, FaCheckCircle } from "react-icons/fa";
import AudioIcon from "../../../assets/icons/audio.js";
import VideoIcon from "../../../assets/icons/video.js";
import FullScreenChat from "../components/FullScreenChat.jsx";
import { useWebSocketChat } from "../../../socket/useSocket.jsx";
import { ReactComponent as MicIcon } from "../../../assets/icons/mic.svg";
import SendIcon from "../../../assets/icons/send.svg";
import aipsychologistIcon from "../../../assets/icons/aipsychologist.svg";
import aidieticianIcon from "../../../assets/icons/aidietician.svg";
import { AuthServices } from "../../auth/services/AuthServices.js";
import { OverlayService } from "../service/OverlayService.js";
import insightsIcon from "../../../assets/icons/insights.svg";
import SlideOver from "../components/SlideOver";
import profilelogo from "../../../assets/icons/logo.svg";




function HomePage() {

  localStorage.setItem("chat_mode", "text");


  // refs
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const prashaBotResponseRef = useRef([]);
  const audioChunksRef = useRef([]);
  const textareaRef = useRef(null);
  const location = useLocation();
  console.log("location.state",location.state);

  // UI state
  const [modalType, setModalType] = useState(null);
  const [showModelSelect, setShowModelSelect] = useState(false);
  const [ShowResumeConversation, setShowResumeConversation] = useState(false);
  const [chatMode, setChatMode] = useState(location.state?.ischatMode ?? false);
  const [chatVisible, setChatVisible] = useState(location.state?.ischatVisible ?? false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pendingExpert, setPendingExpert] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [showTyping, setShowTyping] = useState(false);
  const [activeChat, setActiveChat] = useState("");
  const [showChat, setShowChat] = useState(false);
  const [sessionState, setSessionState] = useState(null);
  const [chatHistory, setChatHistory] = useState([]);
  const [isOverflowHome, setIsOverflowHome] = useState(false);
  const [RefreshPage, setRefreshPage] = useState(false);
  //const [chatVisible, setChatVisible] = useState(ischatVisible);
  const [session, setSession] = useState(location.state?.session ?? null);
  const [basicuser, setBasicuser] = useState(() => {
      const baseUser = localStorage.getItem('basic-user');
      return baseUser
        ? JSON.parse(baseUser)
        : { email: '', user_id: '', first_name: '', last_name:'',profile_picture: '' };
    });

   const [showDetails, setShowDetails] = useState(false);

  const InsightsPanel = lazy(() => import("../components/InsightsPanel"));
  const JournalPanel = lazy(() => import("../components/JournalPanel"));



  const [panel, setPanel] = useState(null);
  const lastCountedIdRef = useRef(null);
  const openPanel = (key) => setPanel(key);
  const closePanel = () => setPanel(null);


  // expert / model selection
  const [selectedExpert, setSelectedExpert] = useState(() => {
    return localStorage.getItem("selectedExpert") || "psychologist";
  });
  const [selectedModel, setSelectedModel] = useState("psychologist");

  // input and user
  const [userInput, setUserInput] = useState(""); // keep controlled from first render
  const [user, setUser] = useState(() => {
    // support both keys used across your files
    const u = localStorage.getItem("user");
    try { return u ? JSON.parse(u) : null; } catch { return u || null; }
  });

  const [date] = useState(
    new Date().toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
    })
  );

  
  const searchParams = new URLSearchParams(location.search);
  const selectedChat = searchParams.get("chat");
  const recognitionRef = useRef(null);
  

const resetHomePage = (newSessionId = null) => {
  // Clear local data
  localStorage.setItem("expertReplyCount", "0");
  localStorage.removeItem("lastCountedMsgId");

  if (newSessionId) {
    localStorage.setItem("conversation_id", newSessionId);
    setRefreshPage(newSessionId);
  } else {
    //localStorage.removeItem("conversation_id");
    localStorage.removeItem("latestConversation");
  }

  lastCountedIdRef.current = null;

  // Reset component state
  setMessages([]);
  setSessionState(null);
  disconnectWebSocket();

  // Optional: If your useEffect depends on URL search param
  /*if (newSessionId) {
    const params = new URLSearchParams(window.location.search);
    params.set("session", newSessionId);
    window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
  } else {
    window.history.replaceState({}, "", window.location.pathname);
  }*/
};


  // hook: support both versions’ API surface
  const {
    sendMessage,
    socket,
    updatePersona,
    updatePatientId,
    updateConversationId, // may be undefined in one version
    connectWebSocket,      // may be undefined in one version
    disconnectWebSocket,   // may be undefined in one version
  } = useWebSocketChat({
    setPatientInfo: () => { },
    setCompleteAudio: () => { },
    onStreamingStart: (data) => handleStreamingStart(data),
    onStreamingText: (data) => handleIncomingStreamingText(data),
    onStreamingAudio: (data) => handleStreamAudio(data),
    onStreamingComplete: (data) => handleStreamingComplete(data),
    onStreamingError: (data) => handleStreamError(data),
    onTranscription: (data) => handleTranscription(data),
    onConversationHistory: () => { },
  });

  const handleSelectExpert = (role) => {
    setSelectedExpert(role);
    updatePersona?.(role);
    if (socket && socket.readyState === 1) {
      socket.close();
    }
  };

  // const toggleRecording = async () => {
  //   if (isRecording) {
  //     stopRecording();
  //   } else {
  //     await startRecording();
  //   }
  // };

  const toggleRecording = () => {
    if (isRecording) {
      // Stop speech recognition
      recognitionRef.current?.stop();
      setIsRecording(false);
    } else {
      startSpeechRecognition();
    }
  };

  const startRecording = async () => {
    if (!navigator.mediaDevices || !window.MediaRecorder) {
      alert("Audio recording is not supported in this browser.");
      return;
    }
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
      console.warn("Already recording.");
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/webm" });
      mediaRecorderRef.current = mediaRecorder;
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) audioChunksRef.current.push(event.data);
      };
      mediaRecorder.onstop = () => {
        sendAudio();
        stream.getTracks().forEach((track) => track.stop());
      };
      mediaRecorder.start();
      setIsRecording(true);
    } catch (error) {
      console.error("Microphone error:", error);
      alert(`Microphone error: ${error.message}`);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  const handleTranscription = (data) => {
    setUserInput(data || "");
    setShowTyping(false);
  };

  // ===== AUTOGROW / AUTOSCROLL (from file 1, enhanced) =====
  const autoResize = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";
    const cs = getComputedStyle(el);
    const maxHStr = cs.maxHeight; // "240px" or "none"
    const maxPx = maxHStr !== "none" ? parseFloat(maxHStr) : Infinity;

    const newH = Math.min(el.scrollHeight, maxPx);
    el.style.height = `${newH}px`;

    setIsOverflowHome(el.scrollHeight > newH + 1);
  };

   const cleanText = (htmlText) => {
    if (!htmlText) return "";
    return htmlText.replace(/<br\s*\/?>/gi, "\n").replace(/<\/?strong>/gi, "");
  };

  useEffect(() => {
    // run after paint for accurate scrollHeight
    requestAnimationFrame(autoResize);
  }, [userInput, showTyping]);

  useEffect(() => {
    if (location.state) {
    setChatVisible(location.state.ischatVisible ?? false);
    setSession(location.state.session ?? null);
    isLoading && setIsLoading(false);
  }

  console.log(
    "chatVisible - session - location.state",
    location.state?.ischatVisible,
    location.state?.session,
    location.state
  );

  resetHomePage(location.state?.session ?? null);

  if(!location.state?.session) {
    setSessionState(null);
    setChatHistory([]);
    setMessages([]);
  }

  }, [location.state]);   


  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    const handleAutoScroll = () => {
      el.scrollTop = el.scrollHeight;
    };
    el.addEventListener("input", handleAutoScroll);
    return () => el.removeEventListener("input", handleAutoScroll);
  }, []);
  // ===== END AUTOGROW / AUTOSCROLL =====

  const addMessage = (text, sender, keywords = [], audio = null) => {
    const newMessage = {
      id: Date.now(),
      text,
      sender,
      timestamp: new Date(),
      isStreaming: false,
      keywords: keywords || [],
      audio,
      isPlaying: false,
    };
    setMessages((prev) => [...prev, newMessage]);
  };

  const handleActivateFullScreen = (e) => {
    if (e.key === "Enter" && !e.shiftKey && userInput.trim() !== "") {

       if (ShowResumeConversation) {
      setShowResumeConversation(false);
    }

      addMessage(userInput, "user");
      // prefer selectedModel if set, fallback to expert
      const model = (selectedModel || selectedExpert).toLowerCase();
      sendMessage(userInput, model);
      setChatMode(true);
      setTimeout(() => setChatVisible(true), 400);
      setUserInput("");
      const el = textareaRef.current;
      if (el) el.style.height = "auto";
      setIsOverflowHome(false);
    }
  };

  const handleIncomingStreamingText = (partialText) => {
    setMessages((prevMessages) => {
      const lastIndex = prevMessages.length - 1;
      const lastMessage = prevMessages[lastIndex];

      if (lastMessage && lastMessage.sender === "ai" && lastMessage.isStreaming) {
        const updatedMessage = {
          ...lastMessage,
          text: (lastMessage.text + " " + partialText).replace(/\s+/g, " "),
        };
        const updatedMessages = [...prevMessages];
        updatedMessages[lastIndex] = updatedMessage;
        return updatedMessages;
      }

      const newMessage = {
        id: Date.now(),
        text: partialText.text,
        sender: "ai",
        timestamp: new Date(),
        isStreaming: true,
        keywords: [],
        audio: null,
        isPlaying: false,
        persona: partialText.persona
      };
      return [...prevMessages, newMessage];
    });
  };

  const handleModalOpen = (type) => setModalType(type);
  const handleModalClose = () => setModalType(null);

  const handleStreamAudio = (data) => {
    // space-safe join like file 1
    const currentChunk = data.text;
    const lastChunk = prashaBotResponseRef.current.at(-1) || "";
    const prevChar = lastChunk.slice(-1);
    const firstChar = currentChunk.charAt(0);
    const needsSpace =
      lastChunk.length > 0 &&
      !/\s/.test(prevChar) &&
      !/^[.,!?;:'")\]]/.test(firstChar) &&
      !/^\s/.test(firstChar);
    prashaBotResponseRef.current.push(needsSpace ? ` ${currentChunk}` : currentChunk);

    const text = prashaBotResponseRef.current.join("");
    setMessages((prev) => {
      const updated = [...prev];
      const lastIndex = updated.length - 1;
      if (lastIndex >= 0 && updated[lastIndex].sender === "ai" && updated[lastIndex].isStreaming) {
        updated[lastIndex] = { ...updated[lastIndex], text };
      }
      return updated;
    });
  };

  const handleModalConfirm = () => {
    if (!selectedExpert) {
      alert("Please select either AI Therapist or AI Dietician first.");
      return;
    }
    const route = modalType === "video" ? "/vsession" : "/session";
    const modelString = selectedExpert === "psychologist" ? "ai psychologist" : "ai dietician";
    navigate(route, {
      state: { sessionType: modalType, selectedExpert, modelString },
    });
  };

  const handleStreamingStart = (data) => {
    //setIsLoading(true);
    // if (fetchedUser) {
    //   setUser(fetchedUser);
    //   localStorage.setItem("user", JSON.stringify(fetchedUser));
    const newMessage = {
      id: data.chatid,
      text: "",
      sender: "ai",
      timestamp: new Date(),
      isStreaming: true,
      keywords: data.extracted_keywords?? null,
      audio: null,
      isPlaying: false,
      expert: data.persona,
      receiver: JSON.parse(localStorage.getItem("user"))?.patient_id
    };
    setMessages((prev) => [...prev, newMessage]);
  };

  const handleStreamingComplete = (data) => {
   // console.log("Streaming complete:", data);
    //console.log("Streaming complete - keywords:", data.extracted_keywords);
    setMessages((prev) => {
      
      const updated = [...prev];
      const lastIndex = updated.length - 1;

      if (lastIndex >= 0 && updated[lastIndex].sender === "ai" && updated[lastIndex].isStreaming) {
        updated[lastIndex] = { ...updated[lastIndex], isStreaming: false ,Test: true};
      }
             
        updated[lastIndex].keywords = data.extracted_keywords?? null;
       

      return updated;
    });
    //console.log("Streaming complete - keywords updated:", messages);
    prashaBotResponseRef.current = [];
    setIsLoading(false);
  };

  const handleStreamError = (data) => {
    console.log(data);
  };

  const handleSend = () => {
    if (!userInput?.trim()) return;
    console.log("ShowResumeConversation:",ShowResumeConversation);
    if (ShowResumeConversation) {
      setShowResumeConversation(false);
    }
    setIsLoading(true);
    addMessage(userInput, "user");
    const model = (selectedModel || selectedExpert).toLowerCase();
    sendMessage(userInput, model);
    
    setUserInput("");
    const el = textareaRef.current;
    if (el) el.style.height = "auto";
    setIsOverflowHome(false);
    setChatMode(true);
    
    
    setTimeout(() => setChatVisible(true), 400);
  };

  const sendAudio = () => {
    const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });
    audioChunksRef.current = [];
    const reader = new FileReader();
    setShowTyping(true);
    reader.onload = () => {
      const base64Audio = reader.result.split(",")[1];
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ audio: base64Audio }));
        console.log("Audio sent to server");
      } else {
        console.error("WebSocket not connected");
        alert("WebSocket not connected. Please refresh the page.");
        setShowTyping(false);
      }
    };
    reader.readAsDataURL(audioBlob);
  };

  const fetchUserData = async () => {
    try {
      const response = await AuthServices.fetchUserData();
      const fetchedUser = response?.data?.data?.user;

      if (response?.status && response.status !== 200) {
        localStorage.clear();
        navigate("/");
      }

      if (fetchedUser) {
        setUser(fetchedUser);
        localStorage.setItem("user", JSON.stringify(fetchedUser));
        if (fetchedUser.patient_id) {
          updatePatientId?.(fetchedUser.patient_id);
           if (localStorage.getItem("userlogin")){  lstConversation(fetchedUser.patient_id);}
        }
        // connect websocket if available in this hook variant
        if (connectWebSocket) connectWebSocket();
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const fetch = async (sessionId) => {
    const response = await OverlayService.fetchConversation(sessionId);
    setChatHistory(response.data);
    // align persona with first message receiver like file 1
    const lastMessage = response.data?.messages?.at(-1);
    const lastmessageExpert = lastMessage?.extracted_keywords?.persona
    ? JSON.parse(lastMessage.extracted_keywords.persona)
    : 'Expert';

    if (lastmessageExpert === "psychologist") {
      updatePersona?.("psychologist");
      setSelectedExpert("psychologist");
    } else {
      updatePersona?.("dietician");
      setSelectedExpert("dietician");
    }
  };

  const renderChatHistory = () => setChatVisible(true);
  let lstConv = null;

 const lstConversation = async (patientid) => {
     try {
          const response = await OverlayService.latestConversation(patientid);
          console.log('latestConversation:', response,response.status);
          if(response.status === 200){ // true if token exists
           localStorage.setItem("latestConversation", JSON.stringify(response.data));
           lstConv = JSON.parse(localStorage.getItem("latestConversation"));
           console.log("lst:",lstConv);
           setShowResumeConversation(true);
           
          }else{
           if (localStorage.getItem("latestConversation")) {localStorage.removeItem("latestConversation");}
          }

          if (localStorage.getItem("userlogin")) {localStorage.removeItem("userlogin");}

        } catch (err) {
          console.error('Error fetching insights:', err);
          
        }
      };
 
  //const patientid = JSON.parse(localStorage.getItem("user"))?.patient_id
  //lstConversation(patientid);

  // prefill when opened from a saved chat
  useEffect(() => {
    if (selectedChat) {
      setMessages([
        { role: "expert", text: `You opened: "${selectedChat}"` },
        { role: "user", text: "Thanks! Let's continue..." },
      ]);
      setActiveChat(selectedChat);
      setShowChat(true);
    }
  }, [selectedChat]);

  // URL param session id
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = RefreshPage? RefreshPage: queryParams.get("session");
    if (sessionId) {
      setSessionState(sessionId);
      fetch(sessionId);
    } else {
      console.log("No session ID in URL");
    }
  }, [location.search,RefreshPage]);

  useEffect(() => {
    if (sessionState) renderChatHistory();
  }, [sessionState]);

  // persona persistence and localStorage
  useEffect(() => {
    if (user && user.patient_id) {
      updatePersona?.(selectedExpert);
    }
  }, [user, selectedExpert]);

  useEffect(() => {
    if (selectedExpert) localStorage.setItem("selectedExpert", selectedExpert);
  }, [selectedExpert]);

  // initial user + optional WS connect
  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    const initSession = async () => {
      let conversationId = localStorage.getItem("conversation_id");

      if (!conversationId) {
        try {
          const response = await OverlayService.createNewSession();
          conversationId = response?.data?.conversation_id;
          if (conversationId) {
            localStorage.setItem("conversation_id", conversationId);
            console.log("🔹 New session created:", conversationId);
          }
        } catch (err) {
          console.error("❌ Failed to create session:", err);
        }
      } else {
        console.log("✅ Existing session found:", conversationId);
      }
    };

    initSession();
  }, []);

  // const startSpeechRecognition = () => {
  //   if (!("webkitSpeechRecognition" in window || "SpeechRecognition" in window)) {
  //     alert("Your browser does not support speech recognition.");
  //     return;
  //   }
  //   const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  //   const recognition = new SpeechRecognition();
  //   recognition.lang = "en-US"; // set language
  //   recognition.interimResults = true; // show partial text
  //   recognition.maxAlternatives = 1;
  //   recognition.onstart = () => {
  //     setIsRecording(true);
  //   };
  //   recognition.onresult = (event) => {
  //     let transcript = "";
  //     for (let i = 0; i < event.results.length; i++) {
  //       transcript += event.results[i][0].transcript;
  //     }
  //     setUserInput(transcript); // populate textarea
  //   };
  //   recognition.onerror = (event) => {
  //     console.error("Speech recognition error:", event.error);
  //     setIsRecording(false);
  //   };
  //   recognition.onend = () => {
  //     setIsRecording(false);
  //   };
  //   recognition.start();
  //   recognitionRef.current = recognition;
  // };

  const startSpeechRecognition = () => {
    if (!("webkitSpeechRecognition" in window || "SpeechRecognition" in window)) {
      alert("Your browser does not support speech recognition.");
      return;
    }
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = true;
    recognition.maxAlternatives = 1;
    let finalTranscript = "";
    recognition.onstart = () => {
      setIsRecording(true);
    };
    recognition.onresult = (event) => {
      let interimTranscript = "";
      for (let i = 0; i < event.results.length; i++) {
        const transcriptChunk = event.results[i][0].transcript;
        if (event.results[i].isFinal) { finalTranscript += transcriptChunk; }
        else { interimTranscript += transcriptChunk; }
      }
      setUserInput((prevTypedText) => {
        let baseText = prevTypedText.split(" ")[0];
        let space = "";
        if (baseText && finalTranscript) {
          const lastChar = baseText.slice(-1);
          const firstChar = finalTranscript.charAt(0);
          if (lastChar !== " " && firstChar !== " ") space = " ";
        }
        return baseText + space + " " + finalTranscript + interimTranscript;
      });
    };
    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setIsRecording(false);
    };
    recognition.onend = () => {
      setIsRecording(false);
      setUserInput((prev) => prev.replace(" ", ""));
    };
    recognition.start();
    recognitionRef.current = recognition;
  };


  return (
    <div className="home-container">
      {/*"chatmode:"+chatMode+"----chatvisible:"+chatVisible+"----session:"+location.state.session*/}
      {!chatVisible ? (
        
        
        
        <div
          className={`home-main-content ${chatVisible ? "fade-out" : "fade-in"}`}
          style={{ display: chatVisible ? "none" : "block" }}
        >
          {/* Greeting and Logo */}
          <div className="greeting" style={{display: !showDetails ? "block" : "none"}}>
            <p className="date">{date && date}</p>
            <h2 className="username">
              Welcome{" "}
              { user?.first_name?.split(" ")?.[0] ||
                JSON.parse(localStorage.getItem("user") || "{}")?.first_name?.split(" ")?.[0] || 
                basicuser?.first_name ||
                "Guest"}
              !
            </h2>
          </div>

          <div className="center-logo-wrapper" style={{display: !showDetails ? "block" : "none"}}>
            <img src={centerLogo} alt="Center Logo" className="center-logo" />
          </div>

          {/* Main content area with scrolling */}
          <div className="chat-content-area">
            {/* This area is intentionally left empty for future messages or content */}

            
                
                <div className="message-keywords" style={
                  {textAlign: 'center', fontSize: '30px', color: '#666', marginBottom: '20px'}
                    
                }>
                  <div style={{display: !showDetails ? "none" : "none"}}>&nbsp;&nbsp;&nbsp;What Can I help with ?</div>
                  <div style={{fontSize:"24px",fontStyle:'italic' ,display: !showDetails ? "block" : "none"}}>Ask me anything about your mental health or diet.</div>
                  

                  <div className="primarytag" style={{display: !showDetails ? "none" : "none", whiteSpace:'wrap', height:"auto", flexWrap: 'wrap', justifyContent: 'center', gap: '10px'}}>
                    <span className="tags-badge"> Depression </span>
                          <span className="tags-badge" > mood swings </span>
                          <span className="tags-badge" > Stress </span>
                          <span className="tags-badge" > Weight loss</span>   
                          <span className="tags-badge" > Anxity </span>
                          <span className="tags-badge" >Sleep issues</span>
                          <span className="tags-badge" >Self-esteem </span>
                          <span className="tags-badge" >Cravings control </span>
                          <span className="tags-badge" style={{cursor: 'pointer'  }}
                           onClick={() => setShowDetails(!showDetails)} >
                            {showDetails ? '(-) less ...' : '(+) more ...'} 
                            
                            </span>
                    </div>

                  <div className="detailtag"  style={{display: showDetails ? "none" : "none"}}>
                          <span className="tags-badge" > Depression </span>
                          <span className="tags-badge" > mood swings </span>
                          <span className="tags-badge" >Fatigue</span>
                          <span className="tags-badge" > Weight gain </span>
                          <span className="tags-badge" > Stress </span>
                          
                          <span className="tags-badge" >Self-esteem </span>
                          <span className="tags-badge" >Concentration </span>
                          
                          <span className="tags-badge" >Mindfulness </span>

                          
                          <span className="tags-badge" >Emotional eating </span>
                           <span className="tags-badge" >Hydration </span>
                          <span className="tags-badge" >Nutrition balance </span>

                          <span className="tags-badge" > Anxity </span>
                          <span className="tags-badge" > Weight loss</span>   
                          <span className="tags-badge" >Burnout </span>

                          <span className="tags-badge" > Insomnia </span>
                         
                          <span className="tags-badge" >Lifestyle changes </span>
                          <span className="tags-badge" >Healthy habits </span>
                          <span className="tags-badge" >Meal planning </span>
                          <span className="tags-badge" >Cravings control </span>
                          <span className="tags-badge" >Digestive health </span>
                          <span className="tags-badge" >Work-life balance </span>
                          <span className="tags-badge" style={{fontSize: '20px',cursor: 'pointer' }}
                           onClick={() => setShowDetails(!showDetails)} >
                            {showDetails ? '(-) less ...' : '(+) more ...'} 
                            
                            </span>
                  </div>
                  </div>


          </div>

          {/* Fixed bottom container for input and controls */}
          <div className="chat-bottom-container">
            {/* Input Box */}
            <div className="input-box">
              <textarea
                ref={textareaRef}
                value={showTyping ? "Transcribing..." : userInput}
                disabled={showTyping}
                onChange={(e) => {
                  setUserInput(e.target.value);
                  requestAnimationFrame(autoResize);
                }}
                onKeyDown={(e) => handleActivateFullScreen(e)}
                className={`chat-textarea ${isOverflowHome ? "is-scrolling" : ""}`}
                placeholder={`Ask Your ${selectedExpert==='psychologist' ? 'Therapist': 'Dietician'}`}
                rows={1}
              />
            </div>

            <div className="chat-controls-row">
              {/* Psychologist (white bg) */}
              <button
                className={`icon-btn icon-btn--white ${selectedExpert === "psychologist" ? "active" : ""}`}
                onClick={() => handleSelectExpert("psychologist")}
                aria-label="AI Therapist"
              >
                <img src={aipsychologistIcon} alt="AI Therapist" width={24} height={24} />
                <span className="icon-label">Therapist</span>
              </button>

              {/* Dietician (white bg) */}
              <button
                className={`icon-btn icon-btn--white ${selectedExpert === "dietician" ? "active" : ""}`}
                onClick={() => handleSelectExpert("dietician")}
                aria-label="AI Dietician"
              >
                <img src={aidieticianIcon} alt="Dietician" width={24} height={24} />
                <span className="icon-label">Dietician</span>
              </button>

              {/* Insights (white bg) 
              <button
                className="icon-btn icon-btn--white"
                onClick={() => openPanel("insights")}
                aria-label="Insights"
              >
                <img src={insightsIcon} alt="Insights" width={24} height={24} />
                <span className="icon-label">Insights</span>
              </button>*/}

              {/* Mic (purple bg + white icon) */}
              <button
                onClick={toggleRecording}
                disabled={showTyping}
                className="icon-btn icon-btn--white"
                aria-label={isRecording ? "Stop recording" : "Start recording"}
              >
                {isRecording ? <FaStop /> : <MicIcon />}
              </button>

              {/* Audio (purple bg + white icon) */}
              <button
                className="icon-btn icon-btn--primary"
                onClick={() => handleModalOpen("audio")}
                aria-label="Audio"
              >
                <AudioIcon width={20} height={20} />
              </button>

              {/* Video (purple bg + white icon) */}
              <button
                className="icon-btn icon-btn--primary"
                onClick={() => handleModalOpen("video")}
                aria-label="Video"
              >
                <VideoIcon width={20} height={20} />
              </button>

              {/* Send (separate, always visible; enabled only if there’s text) */}
              <button
                className="icon-btn icon-btn--primary send-btn"
                onClick={handleSend}
                disabled={!userInput || !userInput.trim()}
                aria-label="Send"
              >
                <img src={SendIcon} alt="Send" width={20} height={20} />
              </button>
            </div>

          </div>
        </div>
      ) : (
        
        <FullScreenChat
          handleModalOpen={handleModalOpen}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          messages={messages}
          addMessage={addMessage}
          sendMessage={sendMessage}
          messagesEndRef={messagesEndRef}
          userInput={userInput}
          setUserInput={setUserInput}
          autoResize={autoResize}
          setShowConfirmation={setShowConfirmation}
          selectedExpert={selectedExpert}
          toggleRecording={toggleRecording}
          showTyping={showTyping}
          isRecording={isRecording}
          chatHistory={chatHistory}
          onExpertChange={handleSelectExpert}
          setChatVisible={setChatVisible}
        />
      )}



      {/* Confirmation Modal */}
      {modalType && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3 className="modal-title">Confirmation</h3>
            <p className="modal-text">
              To start a {modalType} session with <strong>{selectedExpert}</strong>?
            </p>
            <div className="modal-actions">
              <button className="cancel-btn" onClick={handleModalClose}>
                Cancel
              </button>
              <button className="start-btn" onClick={handleModalConfirm}>
                Start
              </button>
            </div>
          </div>
        </div>
      )}

      {showModelSelect && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div className="modal-drag-indicator" />
            <h3 className="modal-title">Choose Your AI Model</h3>
            <div className="model-options">
              {["AI Psychologist", "AI Dietician"].map((model) => (
                <div
                  key={model}
                  className={`model-option ${selectedModel === model ? "selected" : ""}`}
                  onClick={() => setSelectedModel(model)}
                >
                  <span>{model}</span>
                  <input type="radio" checked={selectedModel === model} readOnly />
                </div>
              ))}
            </div>
            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => setShowModelSelect(false)}>
                Cancel
              </button>
              <button
                className="start-btn"
                disabled={!selectedModel}
                onClick={() =>
                  navigate("/session", {
                    state: { selectedModel, selectedExpert, sessionType: modalType },
                  })
                }
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      <SlideOver
        title={
          panel === "insights"
            ? "Insights"
            : panel === "mood"
              ? "Mood"
              : panel === "journal"
                ? "Journal"
                : ""
        }
        isOpen={!!panel}
        onClose={closePanel}
      >
        {panel && (
          <Suspense fallback={<div>Loading…</div>}>
            {panel === "insights" && <InsightsPanel onClose={closePanel} />}
            {panel === "journal" && <JournalPanel onClose={closePanel} />}
            {/* add Mood or other panels here in the same way */}
          </Suspense>
        )}
      </SlideOver>


      {showConfirmation && (
        <div className="chat-confirmation-overlay">
          <div className="chat-confirmation-box">
            <h4>Confirmation</h4>
            <p>Ending current session. Starting session with the {pendingExpert}.</p>
            <div className="chat-confirmation-buttons">
              <button
                className="outline-btn"
                onClick={() => {
                  setSelectedExpert(pendingExpert);
                  setUserInput("");
                  setShowConfirmation(false);
                }}
              >
                Start New
              </button>
              <button className="filled-btn" onClick={() => setShowConfirmation(false)}>
                Stay
              </button>
            </div>
          </div>
        </div>
      )}

  

      {ShowResumeConversation && (
        <div className="chat-confirmation-conversation">
          <div className="chat-confirmation-boxConv">
            <button
      className="close-icon"
      onClick={() => setShowResumeConversation(false)}
    >
      ✕
    </button>
            <h4>Resume your last conversation </h4>
          
            <p>
                You were discussing with our AI{" "}
                {(() => {
                  try {
                    const conv = JSON.parse(localStorage.getItem("latestConversation"));
                    const persona = conv?.extracted_keywords
                      ? JSON.parse(conv.extracted_keywords)?.persona
                      : null;
                    return persona || "Expert";
                  } catch {
                    return "Expert"; // fallback
                  }
                })()}{" "}
                & team about
            </p>  
               <p><b>{JSON.parse(localStorage.getItem("latestConversation")).title}.</b></p>
            
            <span><small style={{textAlign:"left"}}><i>{
            
            (() => {
                    const data = JSON.parse(localStorage.getItem("latestConversation") || "{}");
                    const txt = data.summary_text
                    ? JSON.parse(data.summary_text).summary
                    : cleanText(data.message_text) || "";
                    return txt.length > 200 ? txt.slice(0, 200) + "..." : txt;
            })()
            
            }</i></small></span><br/><p></p>
            <div className="chat-confirmation-buttons">
              <button
                className="outline-btn"
                onClick={() => {
                
                /*localStorage.setItem("expertReplyCount", "0");
               // window.location.href = "/home";

                disconnectWebSocket();
                setShowResumeConversation(false);*/

                //navigate("/home", { replace: true });

                // Optionally force HomePage's effect to run again
                setSessionState(null);
                setMessages([]);

                setShowResumeConversation(false);
                resetHomePage();  // start a fresh session
                }}
              >
                Start New
              </button>
              <button className="filled-btn" onClick={() => {
                        /*
                        lstConv=JSON.parse(localStorage.getItem("latestConversation"));
                        localStorage.setItem("expertReplyCount", "0");
                        lastCountedIdRef.current = null;
                        localStorage.removeItem("lastCountedMsgId");
                        localStorage.setItem("conversation_id", lstConv.conversation_id);
*/
                        /*window.location.href = `/home?session=${encodeURIComponent(
                          lstConv.conversation_id
                        )}`;
                  */
                       /* navigate(`/home?session=${encodeURIComponent(lstConv.conversation_id)}`, {
                        replace: true,
                        });

                        window.dispatchEvent(new PopStateEvent("popstate"));
                setShowResumeConversation(false);
*/
                const lstConv = JSON.parse(localStorage.getItem("latestConversation"));
                setShowResumeConversation(false);
                resetHomePage(lstConv.conversation_id);  // resume old session
              }}>
                Resume
              </button>
            </div>
          </div>
        </div>
      )
      }


    </div>

  );
}

export default HomePage;
